import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { onFetchDashboard } from '../actions/entry';
import {
  isCoreInitializingSelector,
  devicesSelector,
  itemsSelector,
  dashboardSelector,
  alertsOccurSelector,
} from '../selectors';
import Dashboard from '../components/Dashboard';

const mapStateToProps = (state) => {
  const isCoreInitializing = isCoreInitializingSelector(state);
  const devices = devicesSelector(state);
  const items = itemsSelector(state);
  const dashboard = dashboardSelector(state);
  const alertsOccur = alertsOccurSelector(state);

  return {
    dashboard,
    devices,
    items,
    alertsOccur,
    isInitializing: isCoreInitializing,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchDashboard,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
